export default {
    INIT: 'INIT',
    SET_REPAIRERS: 'SET_REPAIRERS',
    SET_ACTIVE_REPAIRER: 'SET_ACTIVE_REPAIRER',
    EDIT_REPAIRER_NOTES: 'EDIT_REPAIRER_NOTES',
    EDIT_REPAIRER_LOCATION_ACTIVE: 'EDIT_REPAIRER_LOCATION_ACTIVE',
};
